export enum ERTGender {
  Male = 0,
  Female = 1,
}

export enum RespiratoryType {
  Regular = 0,
  Shallow = 1,
  Labored = 2,
  Bilateral = 3,
}

export enum PatientType {
  Regular = 0,
  Irregular = 1,
}

export enum ConsciousnessLevel {
  AVPU = 0,
  Alert = 1,
  Voice = 2,
  Pain = 3,
  Unresp = 4,
}

export enum SkinCondition {
  Cool = 0,
  Dry = 1,
  Warm = 2,
  Wet = 3,
}

export enum PulseType
{
    Reg = 0,
    Irregular = 1,
}
